import React, { useState } from "react";
import { useModal } from "./ModalContext";
import toast , { Toaster } from "react-hot-toast";
import logo from "../assets/images/BIOME-Logo.png";
import { getUserSession, setUserSession } from "../utils/userSession";

const RegisterModal = () => {
  const { showModal, closeModal, redirectUrl } = useModal();
  const savedSession = getUserSession();

  const [form, setForm] = useState({
    name: savedSession?.name || "",
    email: savedSession?.email || "",
    mobile: savedSession?.mobile || "",
  });

  const [loading, setLoading] = useState(false);

  if (!showModal) return null;

  // 🔍 Validation
  const validate = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^[6-9]\d{9}$/; // Indian numbers
    const nameRegex = /^[a-zA-Z\s.'-]{2,50}$/;

    if (!nameRegex.test(form.name.trim())) {
      toast.error("Enter a valid name");
      return false;
    }

    if (!emailRegex.test(form.email)) {
      toast.error("Enter valid email");
      return false;
    }

    if (!phoneRegex.test(form.mobile)) {
      toast.error("Enter valid 10-digit mobile number");
      return false;
    }

    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) return;

    setLoading(true);

    try {
      const response = await fetch(
        "/api/register.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            name: form.name.trim(),
            email: form.email,
            mobile: form.mobile,
          }),
        }
      );

      const data = await response.json();

      if (data.status === "success") {
        toast.success("Registered successfully 🎉");

        setUserSession({
          name: form.name.trim(),
          email: form.email,
          mobile: form.mobile,
        });

        closeModal();

        if (redirectUrl) {
          setTimeout(() => {
            window.location.href = redirectUrl;
          }, 1000);
        }
      } else if (data.status === "exists") {
        toast("Already registered");
        setUserSession({
          name: form.name.trim(),
          email: form.email,
          mobile: form.mobile,
        });
        closeModal();
      } else {
        toast.error("Something went wrong");
      }
    } catch (err) {
      console.error(err);
      toast.error("Server error");
    }

    setLoading(false);
  };

  return (
    <div className="modal-overlay">
      <Toaster/>
      <div className="modal">
        <div className="modal-header">
         <h1 className="modal-title">Register to Continue with</h1>
         <img className="modal-responsive" src={logo}/>
       </div>

        <form onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder="Name"
            name="name"
            value={form.name}
            onChange={(e) =>
              setForm({ ...form, name: e.target.value })
            }
            required
          />

          <input
            type="email"
            placeholder="Email"
            name="email"
            value={form.email}
            onChange={(e) =>
              setForm({ ...form, email: e.target.value })
            }
            required
          />

          <input
            type="tel"
            placeholder="Mobile Number"
            name="mobile"
            value={form.mobile}
            maxLength="10"
            onChange={(e) =>
              setForm({
                ...form,
                mobile: e.target.value.replace(/\D/g, ""), // only numbers
              })
            }
            required
          />
          <div className="modal-footer">
          <button type="submit" disabled={loading}>
                    {loading ? "Submitting..." : "Submit"}
                  </button>
          </div>
        </form>

        <button onClick={closeModal} className="close-btn">
          <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" fill="currentColor" class="bi bi-x-circle-fill" viewBox="0 0 16 16">
             <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293z"/>
          </svg>
        </button>
      </div>
    </div>
  );
};

export default RegisterModal;